import React from 'react';
import { FadeIn } from './ui';
import { XCircle } from 'lucide-react';
const failedMethods = [{
  title: 'Dietas Keto extremas',
  desc: 'Elevan el cortisol en mujeres maduras, bloqueando la pérdida de peso a largo plazo.'
}, {
  title: 'Cardio intenso',
  desc: 'Destruye el poco músculo que nos queda, bajando tu tasa metabólica basal.'
}, {
  title: 'Restricción calórica severa',
  desc: 'Apaga tu señal de saciedad, provocando antojos incontrolables de dulce por la tarde.'
}, {
  title: 'Ayuno intermitente mal aplicado',
  desc: 'Dispara la ansiedad y destruye la calidad de tu sueño profundo.'
}, {
  title: "Suplementos 'quemagrasas'",
  desc: 'Solo estresan más a tus glándulas suprarrenales ya agotadas.'
}];
export function FailedMethodsSection() {
  return <section className="bg-sage/20 py-20 px-6 md:py-28" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <FadeIn data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy text-center mb-16" data-id="element-15">
            Por Qué Lo Que Has Probado No Funcionó
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-16">
          {failedMethods.map((method, index) => <FadeIn key={index} delay={index * 0.1} className="bg-white p-8 rounded-2xl shadow-sm border border-sage/30" data-id="element-17">
              <div className="flex items-start gap-4" data-id="element-18">
                <XCircle className="w-8 h-8 text-coral flex-shrink-0 mt-1" data-id="element-19" />
                <div data-id="element-20">
                  <h3 className="text-xl font-bold text-navy mb-2" data-id="element-21">
                    {method.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-22">{method.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}